import { ACCEPTED, ACCOUNT_PASSWORD, FLOW_TYPE } from '../../constants/common-enums';
let instance = null;
/**
 * DcfLaunchData Class used for mapping DCF data
 *  - Singleton class
 *  - Used to update store when DCF launches
 */
class DcfLaunchData {
  /**
   * Default constructor
   *    - Multiple instantiation will provide same instance(First time instance)
   *    - inits public props
   */
  constructor() {
    if (!instance) {
      instance = this; // eslint-disable-line consistent-this
    }
    this.reset();
    return instance;
  }
  /**
   * Returns merchantConfigs
   * @returns {object} _merchantConfigs
   */
  get customProps() {
    return this._customProps;
  }

  /**
   * Sets userInfo and prevents recurring changes to inital value
   * @param {object} userInfo
   */
  setUserInfo(userInfo) {
    Object.assign(this._customProps.userInfo, userInfo);
  }

  /**
   * Sets tokens and prevents recurring changes to inital value
   * @param {object} tokens
   */
  setTokens(tokens) {
    Object.assign(this._customProps.tokens, tokens);
  }

  /**
   * Sets transfer and prevents recurring changes to inital value
   * @param {object} transfer
   */
  setTransfer(transfer) {
    Object.assign(this._customProps.transfer, transfer);
  }

  /**
   * Set xAuthCode
   * @param {object} xAuthCode
   */
  setXAuthCode(xAuthCode) {
    Object.assign(this._customProps.tokens, { xAuthCode });
  }

  /**
   * Set dcfActionCode
   * @param {string} dcfActionCode
   */
  setDcfActionCode(dcfActionCode) {
    this._customProps.dcfActionCode = dcfActionCode;
  }

  /**
   * Set showVdcpIno
   * @param {boolean} showVdcpIno
   */
  setShowVdcpIno(showVdcpIno) {
    this._customProps.showVdcpIno = showVdcpIno;
  }

  /**
   * Set setSignOut
   * @param {boolean} signOut
   */
  setSignOut(signOut) {
    this._customProps.isSignedOut = signOut;
  }

  /**
   * Set step up grant
   * @param {boolean} grant
   */
  setGrantInfo(grant) {
    this._customProps.stepUp.grant = grant;
  }
  /**
   * Reset custom props
   */
  reset() {
    // everything need to be reset to default state except ino decision
    let isINO = true;
    if (this._customProps && typeof this._customProps.showVdcpIno === 'boolean') {
      isINO = this._customProps.showVdcpIno;
    }
    this._customProps = {
      dcfActionCode: null,
      idTokens: null,
      idValidationSessionId: null,
      payMode: false,
      paymentRequest: {},
      profileCountry: null, // to host api response country form system-sdk. used to override country values during transition
      profileLocale: null, // to host api response locale form system-sdk. used to override locale values during transition
      routeBeforeLaunchDcf: null,
      showVDCPFlow: true,
      showVdcpIno: isINO,
      stepUp: {
        grant: false
      },
      tokens: {
        expiresIn: 0,
        refreshToken: null,
        tncEntryInfo: [],
        tokenExpires: null,
        xAuthCode: null
      },
      transfer: {
        addCardInfo: {},
        authType: 'password',
        deeplinkFlow: '',
        otpProvider: ''
      },
      userInfo: {
        accountType: ACCOUNT_PASSWORD,
        alwaysRememberMe: false,
        assuranceData: {},
        countryCode: 'US', // default country code
        customFlowType: null,
        email: '',
        emailHash: null,
        firstName: '',
        flowType: FLOW_TYPE.STD,
        isCfeNewUser: false,
        isComplianceTncPassed: false,
        isLocked: false,
        isLoggedInOtpUser: false,
        isNonVisaRecognizedUser: false,
        isOptimizedHalfSheetEligible: false,
        isPasswordlessUser: false,
        isPrivacyPolicyPresent: false,
        isRecognizedUser: false,
        isStepupInitiated: false,
        isTncFlow: false,
        isUserAuthenticated: false,
        isUserConsentedPrefill: false,
        isVsb: false,
        isVsbButtonless: false,
        lastName: '',
        locale: 'en-US', // default locale
        lookupStatus: null,
        phone: '',
        ssiErmFlow: '',
        tncStatus: ACCEPTED
      }
    };
  }

  /**
   * Resets token state
   */
  resetTokenState() {
    Object.assign(this._customProps.tokens, {
      expiresIn: 0,
      refreshToken: null,
      tokenExpires: null,
      xAuthCode: null
    });
  }

  setRouteBeforeLaunchDcf(routeBeforeLaunchDcf) {
    this._customProps.routeBeforeLaunchDcf = routeBeforeLaunchDcf;
  }
}

export default new DcfLaunchData();
